import { makeStyles } from 'tss-react/mui';

const useStylesFloatingFooterBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  floatingFooterBlock: {
    position: 'sticky',
    bottom: 0,
    padding: 20,
    background: theme.palette.common.white,
  },
}));

export default useStylesFloatingFooterBlock;
